export default "__VITE_ASSET__Nd9fvwu1__"